import { getModule } from "@/modules/arcgisAPI"
import config from "@/modules/appConfig"

let activeWidget: any = null
export function setActiveWidget(type: any) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve: any) => {
    const view = config.activeView
    if (type) {
      switch (type) {
        case "distance3D":
          // eslint-disable-next-line no-case-declarations
          const DirectLineMeasurement3D = await getModule("esri/widgets/DirectLineMeasurement3D")
          activeWidget = new DirectLineMeasurement3D({
            view
          })
          activeWidget.viewModel.newMeasurement()
          break
        case "area3D":
          // eslint-disable-next-line no-case-declarations
          const AreaMeasurement3D = await getModule("esri/widgets/AreaMeasurement3D")
          activeWidget = new AreaMeasurement3D({
            view
          })
          activeWidget.viewModel.newMeasurement()
          break
        case "distance2D":
          // eslint-disable-next-line no-case-declarations
          const DirectLineMeasurement2D = await getModule("esri/widgets/DistanceMeasurement2D")
          activeWidget = new DirectLineMeasurement2D({
            view
          })
          activeWidget.viewModel.newMeasurement()
          break
        case "area2D":
          // eslint-disable-next-line no-case-declarations
          const AreaMeasurement2D = await getModule("esri/widgets/AreaMeasurement2D")
          activeWidget = new AreaMeasurement2D({
            view
          })
          activeWidget.viewModel.newMeasurement()
          break
      }
      resolve()
    }
  })
}

export function clearActiveWidget() {
  if (activeWidget) {
    activeWidget.destroy()
    activeWidget = null
  }
}
